import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import API from "../Network/API";
import PostLoader from '../assets/loader.gif';
import CourseCard from "../components/CourseCard";
import ScheduleSlot from "../components/ScheduleSlot";
import RelatedTeachers from "../components/RelatedTeachers";
import { teacherPath } from "../services/Helper";
import { useTranslation } from "react-i18next";
export default function TeacherView() {
  const { t } = useTranslation();
  const prams = useParams();
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // Already loaded: this is the canonical-URL redirect below, no need to fetch again.
    if (data?.slug && data.slug === prams.slug) return;
    setLoading(true)
    API.get(`/v1/oauth/teacher/${prams.slug}/show`).then((response) => {
      setLoading(false)
      const teacher = response.data.data
      setData(teacher)
      // Old /teacher/30 links (or a renamed teacher) land on the canonical slug URL.
      if (teacher?.slug && teacher.slug !== prams.slug) {
        const prefix = location.pathname.startsWith("/app") ? "/app" : "";
        navigate(teacherPath(teacher, prefix), { replace: true })
      }
    }).catch((error) => {
      setLoading(false)
      if (error?.response?.status === 404) {
        navigate(location.pathname.startsWith("/app") ? "/app/teachers" : "/teachers", { replace: true })
      }
    }).finally(
      window.scrollTo(0, 0)
    );
  }, [prams.slug]);
  return (
    <>
      {isLoading ?
        <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
          <img src={PostLoader} alt={t('teacherView.post_loader')} height={80} width={80} />
        </div>
        :
        <div className="courseDetails teacher-profile">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-12 offset-md-2">
                <div className="mainInfoWrapper">
                  <div className="mainInfoWrapperAuthorInfo">
                    <div className="d-flex flex-column flex-md-row">
                      <div className="flex-shrink-0">
                        <div className="AvatarWrapper position-relative">
                          <img src={data?.avatar} alt={data?.name} />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <div className="Authorinfo">
                          <div className="step-upload-photos-name d-flex  align-items-center">
                            <h4 className="me-2 fs-24-600 m-0">{data?.name}</h4>
                            {/* <img src="assets/img/bd.svg" alt="BD" /> */}
                          </div>
                          <p className="m-0 fs-16-400">{data?.teacher_info?.bio}</p>
                        </div>
                        <div className="step-upload-photos-text d-flex mb-2">
                          <i className="fa-light fa-graduation-cap me-2" />
                          <p className="m-0">{data?.teacher_info?.education_title}</p>
                        </div>
                        <div className="step-upload-photos-text mb-2 d-flex">
                          <i className="fa-light fa-quote-left me-2" />
                          <p className="m-0">{t("teacherView.speaks")}
                            {data?.languages?.length > 0 && data?.languages?.map((lang, i) => (
                              <>
                                <span className="ms-1">{lang.name} </span><span className="badge lang-badge text-uppercase">{lang.type}</span>
                              </>
                            ))}
                          </p>
                        </div>
                        <div className="step-upload-photos-text d-flex">
                          <i className="fa-light fa-user me-2" />
                          <p className="m-0">{t("teacherView.lessons_count", { count: data?.lessons_count })}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mainInfoWrapperTab">
                    <div className="courseDetailsInfoWrapperTab">
                      <div className="dashboard__nav-wrap">
                        <ul className="nav nav-tabs" id="courseTab" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="Specialties" data-bs-toggle="tab" data-bs-target="#Specialties-tab-pane" type="button" role="tab" aria-controls="Specialties-tab-pane" aria-selected="false" tabIndex={-1}>
                              {t("teacherView.all_lessons")}
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button className="nav-link " id="About" data-bs-toggle="tab" data-bs-target="#About-pane" type="button" role="tab" aria-controls="About-pane" aria-selected="true">
                              {t("teacherView.about")}
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button className="nav-link" id="Schedule" data-bs-toggle="tab" data-bs-target="#Schedule-tab-pane" type="button" role="tab" aria-controls="Schedule-tab-pane" aria-selected="false" tabIndex={-1}>
                              {t("teacherView.schedule")}
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button className="nav-link" id="Reviews" data-bs-toggle="tab" data-bs-target="#Reviews-tab-pane" type="button" role="tab" aria-controls="Reviews-tab-pane" aria-selected="false" tabIndex={-1}>
                              {t("teacherView.reviews_tab", { count: 0 })}
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content" id="courseTabContent">
                        <div className="tab-pane fade active show" id="Specialties-tab-pane" role="tabpanel" aria-labelledby="Specialties-tab" tabIndex={0}>
                          <div className="courseDetailsTabSpecialties">
                            <div className="row">
                              {data?.courses?.length > 0 && data?.courses?.map((course, j) => (
                                <div className="col-lg-4 col-sm-6" key={j}>
                                  <CourseCard course={course} />
                                </div>
                              ))}

                            </div>
                          </div>
                          
                        </div>


                        <div className="tab-pane fade" id="Schedule-tab-pane" role="tabpanel" aria-labelledby="Schedule-tab" tabIndex={0}>
                          <div className="courseDetailsTabHeading">
                            <h2 className="fs-24-600 mb-0">{t("teacherView.available")}</h2>
                          </div>
                          {/* <ScheduleSlot schedule={data?.teacher_schedules} /> */}
                        </div>

                        <div className="tab-pane fade" id="About-pane" role="tabpanel" aria-labelledby="About" tabIndex={0}>
                          <div className="courseDetailsTabHeading">
                            <h2 className="fs-24-600 mb-0">{t("teacherView.about")}</h2>
                          </div>
                          <div className="courseDetailsTabDec">
                            <p className="fs-16-400">
                              {data?.about}
                            </p>

                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <RelatedTeachers slug={data?.slug} />
          </div>
        </div>
      }
    </>
  )
}